import * as Types from '../../generated-types';

import { GraphQLClient } from 'graphql-request';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
export type CreatePunchMutationVariables = Types.Exact<{
  dayId: Types.Scalars['ID'];
  in?: Types.InputMaybe<Types.Scalars['Time']>;
  out?: Types.InputMaybe<Types.Scalars['Time']>;
  location: Types.Scalars['String'];
}>;


export type CreatePunchMutation = { __typename?: 'Mutation', createPunch?: { __typename?: 'Punch', documentId: string, in?: any | null, out?: any | null, location: string } | null };

export type UpdatePunchMutationVariables = Types.Exact<{
  punchId: Types.Scalars['ID'];
  in?: Types.InputMaybe<Types.Scalars['Time']>;
  out?: Types.InputMaybe<Types.Scalars['Time']>;
  location: Types.Scalars['String'];
}>;


export type UpdatePunchMutation = { __typename?: 'Mutation', updatePunch?: { __typename?: 'Punch', documentId: string, in?: any | null, out?: any | null, location: string, pendingPunches: Array<{ __typename?: 'PendingPunch', documentId: string, in?: any | null, out?: any | null, approved?: boolean | null, createdAt?: any | null } | null> } | null };

export type DeletePunchMutationVariables = Types.Exact<{
  punchId: Types.Scalars['ID'];
}>;


export type DeletePunchMutation = { __typename?: 'Mutation', deletePunch?: { __typename?: 'DeleteMutationResponse', documentId: string } | null };


export const CreatePunchDocument = `
    mutation CreatePunch($dayId: ID!, $in: Time, $out: Time, $location: String!) {
  createPunch(data: {day: $dayId, location: $location, in: $in, out: $out}) {
    documentId
    in
    out
    location
  }
}
    `;
export const useCreatePunchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreatePunchMutation, TError, CreatePunchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreatePunchMutation, TError, CreatePunchMutationVariables, TContext>(
      ['CreatePunch'],
      (variables?: CreatePunchMutationVariables) => fetcher<CreatePunchMutation, CreatePunchMutationVariables>(client, CreatePunchDocument, variables, headers)(),
      options
    );
export const UpdatePunchDocument = `
    mutation UpdatePunch($punchId: ID!, $in: Time, $out: Time, $location: String!) {
  updatePunch(
    documentId: $punchId
    data: {location: $location, in: $in, out: $out}
  ) {
    documentId
    in
    out
    location
    pendingPunches(pagination: {limit: -1}) {
      documentId
      in
      out
      approved
      createdAt
    }
  }
}
    `;
export const useUpdatePunchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePunchMutation, TError, UpdatePunchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePunchMutation, TError, UpdatePunchMutationVariables, TContext>(
      ['UpdatePunch'],
      (variables?: UpdatePunchMutationVariables) => fetcher<UpdatePunchMutation, UpdatePunchMutationVariables>(client, UpdatePunchDocument, variables, headers)(),
      options
    );
export const DeletePunchDocument = `
    mutation DeletePunch($punchId: ID!) {
  deletePunch(documentId: $punchId) {
    documentId
  }
}
    `;
export const useDeletePunchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePunchMutation, TError, DeletePunchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePunchMutation, TError, DeletePunchMutationVariables, TContext>(
      ['DeletePunch'],
      (variables?: DeletePunchMutationVariables) => fetcher<DeletePunchMutation, DeletePunchMutationVariables>(client, DeletePunchDocument, variables, headers)(),
      options
    );